import { useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Handle, Position } from '@xyflow/react';
import MoleculeInfo from '../ResultsTable/MoleculeInfo.js';
import ResultInfoText from '../ResultsTable/ResultInfoText.js';
import CopyTextUniversalButton from '../CopyTextUniversalButton.js';
import MoleculeNodeEvidence from './moleculeNodeEvidence.js';
 
 /// data: srcImg, name, marts, 
function MoleculeNodeContent({ data }) {
  const onChange = useCallback((evt) => {
    console.log(evt.target.value);
  }, []);
 
  return (
    <div>
      <div>
       <Link to={`/record/${data.marts}`} style={{ textDecoration: 'none', color: 'inherit' }}>
        <img
          src={data.srcImg}
          alt={data.name}
          style={{ height: '150px' }}
        /> <br></br>
        <ResultInfoText text={data.name == "unnamed_intermediate" ? data.marts : data.name} fontSize={"14px"} onClick={() => {}}/>
         </Link>
        <CopyTextUniversalButton smiles={data.smiles} />
        <MoleculeNodeEvidence sources={data.evidence_sources} />
      </div>
      
     </div> 
  );
}
 
export default MoleculeNodeContent;